import { cn } from '@/lib/utils'
import { Input as InputShadCn } from '@/ui/Shadcn/input'
import { Label } from '@/ui/Shadcn/label'
import { memo } from 'react'

interface InputProps extends React.ComponentProps<typeof InputShadCn> {
  label?: string
  className?: string
  id?: string
  showPlaceholder?: boolean
  [key: string]: any
}

const Input = ({
  label,
  className,
  id,
  showPlaceholder,
  ...props
}: InputProps) => (
  <div className={cn(`relative flex flex-col`, className)}>
    {label && (
      <Label htmlFor={id} className="top-md left-md absolute text-neutral-600">
        {label} {props?.required && '*'}
      </Label>
    )}
    <InputShadCn
      id={id}
      className={cn(
        'px-md pb-xs pt-lg basic-input input-focus textstyle-md-regular h-auto',
        className
      )}
      placeholder={showPlaceholder ? props?.placeholder || label : undefined}
      {...props}
    />
  </div>
)

Input.displayName = 'Input'

export default memo(Input)
